import {inject, Injectable} from '@angular/core';
import {RuntimeService} from "../../../core/services/runtime.service";

interface Window {
    gtag?: (...args: any[]) => void;
}

@Injectable({
    providedIn: 'root'
})
export class WindowRefService {
    readonly #runtimeService = inject(RuntimeService);

    constructor() {
    }

    get nativeWindow(): Window | null {
        return this.#runtimeService.isBrowser ? (window as Window) : null;
    }
}
